import { translator } from 'core/localization/localization';

const i18n = translator({
	'Show items with value that: ': {
		no: 'Vis elementer med verdi som: ',
	},
	'Starts with': {
		no: 'Starter med',
	},
	'Contains': {
		no: 'Inneholder',
	},
	'Is equal to': {
		no: 'Er lik',
	},
	'Is not equal to': {
		no: 'Er ikke lik',
	},
	'Greater than or equal to': {
		no: 'Større enn eller lik',
	},
	'Greater than': {
		no: 'Større enn',
	},
	'Less than or equal to': {
		no: 'Mindre enn eller lik',
	},
	'Less than': {
		no: 'Mindre enn',
	},
	'Is after or equal to': {
		no: 'Er etter eller lik',
	},
	'Is after': {
		no: 'Er etter',
	},
	'Is before or equal to': {
		no: 'Er før eller lik',
	},
	'Is before': {
		no: 'Er før',
	},
	'Select view...': {
		no: 'Velg visning...',
	},
	'See view': {
		no: 'Se visning',
	},
	'Create view': {
		no: 'Opprett visning',
	},
	'Remove view': {
		no: 'Fjern visning',
	},
	'Update view': {
		no: 'Oppdater visning',
	},
	'Clear view': {
		no: 'Fjern visning',
	},
	'Open view': {
		no: 'Åpne visning',
	},
	'Clear filter and sorting': {
		no: 'Fjern filter og sortering',
	},
	'Show/hide columns': {
		no: 'Vis/skjul kolonner',
	},
	'Grid Columns': {
		no: 'Kolonner',
	},
	'Columns Sorting': {
		no: 'Sortering av kolonner',
	},
	'Filter Preferences': {
		no: 'Filterinnstillinger',
	},
	'Enter new filter name': {
		no: 'Skriv inn nytt filternavn',
	},
	'View updated': {
		no: 'Visning oppdatert',
	},
	'Is in': {
		no: 'Er med i',
	},
	'Is not in': {
		no: 'Er ikke med i',
	},
});

export function getGridFilterMessages() {
	return {
		SHOW_ITEMS: i18n('Show items with value that: '),
		STARTS_WITH: i18n('Starts with'),
		CONTAINS: i18n('Contains'),
		EQ: i18n('Is equal to'),
		NEQ: i18n('Is not equal to'),
		GTE: i18n('Greater than or equal to'),
		GT: i18n('Greater than'),
		LTE: i18n('Less than or equal to'),
		LT: i18n('Less than'),
		IAE: i18n('Is after or equal to'),
		IA: i18n('Is after'),
		IBE: i18n('Is before or equal to'),
		IB: i18n('Is before'),
		SELECT_VIEW: i18n('Select view...'),
		SEE_VIEW: i18n('See view'),
		CREATE_VIEW: i18n('Create view'),
		REMOVE_VIEW: i18n('Remove view'),
		UPDATE_VIEW: i18n('Update view'),
		CLEAR_VIEW: i18n('Clear view'),
		OPEN_VIEW: i18n('Open view'),
		FILTER_RESET: i18n('Clear filter and sorting'),
		SHOW_HIDE_COLUMNS: i18n('Show/hide columns'),
		GRID_COLUMNS: i18n('Grid Columns'),
		COLUMNS_SORTING: i18n('Columns Sorting'),
		FILTER_PREFERENCES: i18n('Filter Preferences'),
		ENTER_NEW_FILTER: i18n('Enter new filter name'),
		VIEW_UPDATED: i18n('View updated'),
		ISIN: i18n('Is in'),
		ISNOTIN: i18n('Is not in'),
	};
}
